// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".day-week {\n  line-height: 1;\n  text-align: center;\n}\n.day-week .day {\n  display: inline-block;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n.day-week .week {\n  display: inline-block;\n  font-size: 13px;\n}\n.day-week-hot .day,\n.day-week-hot .week {\n  color: #E23C58;\n}", ""]);
// Exports
module.exports = exports;
